import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const today = () => new Date().toISOString().split("T")[0];
export const monthKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;

export function useAvailability(fecha) {
  const [availability, setAvailability] = useState({ ranges: [], slots: [] });
  const [dayTaken, setDayTaken] = useState(false);
  const [month, setMonth] = useState(() => new Date());
  const [availableDates, setAvailableDates] = useState([]);
  const [loadingDates, setLoadingDates] = useState(true);

  useEffect(() => {
    axios.get(`${API}/availability`).then(({ data }) => setAvailability(data)).catch((err) => console.warn("availability", err));
  }, []);

  useEffect(() => {
    setLoadingDates(true);
    axios.get(`${API}/available-dates`, { params: { month: monthKey(month) } })
      .then(({ data }) => setAvailableDates(data.available || []))
      .catch(() => setAvailableDates([]))
      .finally(() => setLoadingDates(false));
  }, [month]);

  useEffect(() => {
    if (!fecha) { setDayTaken(false); return; }
    axios.get(`${API}/booked-slots`, { params: { fecha } })
      .then(({ data }) => setDayTaken(Boolean(data.day_taken)))
      .catch(() => setDayTaken(false));
  }, [fecha]);

  const ranges = availability.ranges || [];
  const minDate = today();
  const hasAvailability = ranges.some((r) => r.times.length > 0 && (r.weekdays?.length ?? 7) > 0 && r.end_date >= minDate);

  const timesForDate = (d) => {
    const weekday = (new Date(`${d}T12:00:00`).getDay() + 6) % 7;
    const times = new Set();
    ranges.forEach((r) => {
      const dayOk = !r.weekdays || r.weekdays.includes(weekday);
      if (dayOk && r.start_date <= d && d <= r.end_date) r.times.forEach((t) => times.add(t));
    });
    return [...times].sort();
  };

  const availableSlots = fecha && !dayTaken ? timesForDate(fecha) : [];

  return { minDate, hasAvailability, timesForDate, availableSlots, dayTaken, month, setMonth, availableDates, loadingDates };
}
